module.exports = __webpack_public_path__ + "static/media/img_6.88dbb6a4.png";